export default {
  "paymentPlatformAdmin.thead.index": "#NO",
  "paymentPlatformAdmin.thead.documentId": "DocumentId",
  "paymentPlatformAdmin.thead.bindSite": "BindSite",
  "paymentPlatformAdmin.thead.title": "Title",
  "paymentPlatformAdmin.thead.key": "PlatformKey",
  "paymentPlatformAdmin.thead.icon": "Icon",
  "paymentPlatformAdmin.thead.logo": "Logo",
  "paymentPlatformAdmin.thead.active": "Active",
  "paymentPlatformAdmin.thead.autoLoop": "AutoLoop",
  "paymentPlatformAdmin.thead.payDesc": "PayDesc",
  "paymentPlatformAdmin.thead.remark": "支付平台备注",
  "paymentPlatformAdmin.thead.paymentOpenType": "PaymentOpenType",
  "paymentPlatformAdmin.thead.sort": "Sort",
  "paymentPlatformAdmin.thead.createdAt": "CreatedAt",
  "paymentPlatformAdmin.thead.updatedAt": "UpdatedAt",

  "paymentPlatformAdmin.add": "Add",
  "paymentPlatformAdmin.edit": "Edit",
  "paymentPlatformAdmin.details": "Details",
  "paymentPlatformAdmin.delete": "Delete",

  "paymentPlatformAdmin.thead.action": "Action",
};
